// ProtectedRoute.jsx
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {BottomNavBar} from "../components/bottomNavBar"
function ProtectedRoute({ children }) {
const userUid = useSelector((state) => state.userData.userProfile.Uid);
  if (!userUid) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      <BottomNavBar />
    </>
  );
}


export {ProtectedRoute}